module.exports = __webpack_public_path__ + "static/media/ac.b5655f23.svg";